export const QUERY_EMPLOYEE_TAX_FORM_SCHEMA = "QUERY_EMPLOYEE_TAX_FORM_SCHEMA";
export const QUERY_EMPLOYEE_TAX_FORM_SCHEMA_WITH_VALUES =
  "QUERY_EMPLOYEE_TAX_FORM_SCHEMA_WITH_VALUES";
export const QUERY_EMPLOYEE_TAX_FORMS_CHECKLIST =
  "QUERY_EMPLOYEE_TAX_FORMS_CHECKLIST";
export const QUERY_EMPLOYEE_TAX_FORMS_INSTANCES_BY_PAIR =
  "QUERY_EMPLOYEE_TAX_FORMS_INSTANCES_BY_PAIR";
